export const findTicketStatus = (ticket) => {
	const {
		ticket_category: { status_template },
	} = ticket;

	let ticketStatus = null;
	status_template.forEach((item) => {
		item.statuses.forEach((status) => {
			if (status.id === ticket.integration_data.status) {
				ticketStatus = item;
				return;
			}
		});
	});
	return ticketStatus;
};

export const findCurrStatus = (ticket) => {
	const { integration_data, ticket_category } = ticket;
	const { status } = integration_data;

	let currStatus = null;
	// find valetify status from ticket category status_template
	ticket_category?.status_template.forEach(({ key, statuses }) => {
		const statusFound = statuses.find((item) => item.id === status);
		if (statusFound) {
			currStatus = key;
			return;
		}
	});

	return currStatus;
};

// Statuses that mean the work is done. `completed` and `closed` are template
// keys, not labels — see findCurrStatus.
export const TERMINAL_STATUSES = ["completed", "closed"];

/*
 * Tickets that still represent open work: not archived, and not sitting in a
 * terminal column. Previously the archive guard read
 *   (is_archived && s !== "closed") || (is_archived && s !== "completed")
 * which is true for every status a ticket can hold, so it collapsed to a plain
 * `is_archived` check; and the final return only excluded "closed", so anything
 * in the Completed column counted as active.
 */
export const findActiveTickets = (tickets) => {
	return tickets?.filter((ticket) => {
		if (ticket.is_archived) return false;

		const currStatus = findCurrStatus(ticket);

		// a status id that matches no group in the category template means the
		// template is out of sync — the ticket has no column on the board either,
		// so counting it here would inflate the number with something invisible
		if (!currStatus) return false;

		return !TERMINAL_STATUSES.includes(currStatus);
	});
};
